import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Mpannel =()=>{
const [dasi, setdasi] = useState(false);
const [mona, setmona] = useState(true);
const [prm, setprm] = useState();
const [bkm, setbkm] = useState();
const [noups, setnoups]= useState(false);
const [houps, sethoups]= useState(false);

let juki = null;
let moa = null;
let mos2 = null;
const juka = useRef(null);
const moke = useRef(null);
// const sono = () => {
//     clearTimeout(juki);
//     clearTimeout(moa);
//     clearTimeout(mos2);
//     moveon.current.style.transform = 'translate(-20%)';
//      juki = setTimeout(() => {
        
//         if(moveon.current == null) return;
//         moveon.current.appendChild(moveon.current.firstElementChild);
//         moveon.current.style.transition = 'none';
//         moveon.current.style.transform = 'translate(0%)';
//          moa = setTimeout(() => {
//             moveon.current.style.transition = 'all 0.5s';
//             setmona(!mona);
//             clearTimeout(moa);
//         }, 20);
//         mos2 = setTimeout(() => {
            
//         }, 3000);
//         clearTimeout(juki);
//     }, 800);
// };

const sono = () => {
    if (!moveon.current) return;
    clearTimeout(juka.current);
    clearTimeout(moke.current);
     const monzy = 100 / last?.h?.length;
     const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
     
     moveon.current.style.transition = 'none';
     moveon.current.style.transform = `translateX(-${mabos}%)`;
     void moveon.current.offsetWidth;
 
     requestAnimationFrame(() => {
         moveon.current.style.transition = 'transform 0.5s ease-out';
         moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
     });
 
     juka.current = setTimeout(() => { 
         if(moveon.current == null) return;
         moveon.current.appendChild(moveon.current.firstElementChild);
         moveon.current.style.transition = 'none';
         moveon.current.style.transform = `translate(-${mabos}%)`;
            moke.current = setTimeout(() => {
             moveon.current.style.transition = 'transform 0.5s ease-out';
             setmona(!mona);
         }, 20);
     }, 800);
 };

const kuara = () => {
    setdasi(true);
};
const kirara = () => {
    setdasi(false);
};
const mahina = ()=>{
    setdasi(true);
};
const amena =()=>{
    setdasi(false);
};

const noflow = () =>{
    if(noups){
        return noups;
    }else{
        setnoups(true);
        return false;
    }
};

const ahflow = () =>{
    if(houps){
        return houps;
    }else{
        sethoups(true);
        return false;
    }
};

// const supo = () => {
//     if(noflow()) return;
//     setdasi(true);
//     moveon.current.style.transform = 'translate(-20%)';
    
//     const juki = setTimeout(() => {
//         moveon.current.appendChild(moveon.current.firstElementChild);
//         moveon.current.style.transition = 'none';
//         moveon.current.style.transform = 'translate(0%)';
//         const moa = setTimeout(() => {
//             moveon.current.style.transition = 'all 0.5s';
//             setnoups(false);
//             clearTimeout(moa);
//         }, 20);
//        clearTimeout(juki);
//     }, 800);
// };

const supo = () => {
    if(noflow()) return;
    setdasi(true);
   
    const monzy = 100 / last?.h?.length;
    const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translate(-${mabos}%)`;
    void moveon.current.offsetWidth;
   
    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
    });
      
    const juki = setTimeout(() => {
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
    
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            setnoups(false);
        }, 20);
       clearTimeout(juki);
    }, 800);
};


// const sdwo = () => {
//     if(ahflow()) return;
//     setdasi(true);
//     moveon.current.style.transform = 'translate(20%)';
   
//     const juki = setTimeout(() => {
//         moveon.current.prepend(moveon.current.lastElementChild);
//         moveon.current.style.transition = 'none';
//         moveon.current.style.transform = 'translate(0%)';
//         const moa = setTimeout(() => {
//             moveon.current.style.transition = 'all 0.5s';
//             sethoups(false);
//             clearTimeout(moa);
//         }, 20);
//         clearTimeout(juki);
//     }, 800);    
// };

const sdwo = () => {
    if(ahflow()) return;
    setdasi(true);
    const monzy = 100 / last?.h?.length;
    const mabos = last?.h?.length % 2 == 0 ? monzy / 2 : 0;
    
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;
    
    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(${monzy - mabos}%)`;
    });

    const juki = setTimeout(() => {
        moveon.current.prepend(moveon.current.lastElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            sethoups(false);
        }, 20);
        clearTimeout(juki);
    }, 800);
};

const fnax = async (signal) => {
    const { data : hooko } = await axios.get('/api/carousel', { signal });
    const data = {h : vggle(hooko.main), z : zggle(hooko.subm), a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};
    return data;
};

const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ({signal})=>fnax(signal), 
placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });

useEffect(() => {
    if (dasi == true) return;
    if (!last?.h?.length) return;
    if (last?.h?.length <= 1) return;
    const kci = setTimeout(() => { sono(); }, 3500);
    return () => { clearTimeout(kci);
                   clearTimeout(juka.current);
                   clearTimeout(moke.current);
     };
},
    [mona, dasi, last]);


const uggle =(arar)=>{
    if(arar.length === 0 || arar === undefined) return arar;
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };
     return arar;
};
  
const vggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
    };

    return arar; 
};

const zggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    }else if(arar.length === 4) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    };

    return arar;
};
  

const aggle =(a, b)=>{
    const ugoka = a.concat(b);
    for (let i = ugoka.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
      };
     return ugoka;
};

const moveon = useRef();

const touchu = (e)=>{
    mahina();
    setprm(e.changedTouches[0].pageX);
    setbkm(e.changedTouches[0].pageY);
};

const toucha = (e)=>{
    const disx = prm - e.changedTouches[0].pageX;
    const disy = bkm - e.changedTouches[0].pageY;
    const bangha = Math.abs(disx/disy);
    if(disx > 30 && bangha > 2){
        supo();
        amena();
    }else if(disx < -30 && bangha > 2){
        sdwo();
        amena();
    }else{
        amena();
        return;
    };
};

return(
<div className='maaan'>
<div className='mmoewa'>
{last && <div className='slid' ref={moveon} onMouseOver={kuara} onMouseOut={kirara} onTouchStart={touchu} onTouchEnd={toucha} style={{ '--total-count': last ? last.h.length : 1, '--nanoo': last.h.length%2 == 1 ? 0 : 1 }}>
        {last && last?.h?.map((con, i)=>{ return (<div className='iware'>
            <Link to={`../../ajo/${con.link}`} className='iwang' onClick={()=>{ 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            <div className='fly'>
                <p className='flzma'>{con.period}</p>
                <p className='flzma'>{con.title}</p>
            </div>
            </Link>
        </div>)})}
    </div>}
   {last?.h?.length > 1 && <div className='contra'>
        <span className='ape' onClick={supo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sidel.png'}/></span>
        <span className='due' onClick={sdwo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sider.png'}/></span>
    </div>}
</div>
</div>
)
};

export default Mpannel;